export default __webpack_public_path__ + "static/media/no-sign.1d53ab87.gif";